import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { ComplementRejectResponse, FseConfig, FseConfigResponse, FseUserAuthentication } from 'app/model';
import { FSE_URL, SETTING_URL } from 'app/urls';
import { Observable, switchMap, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FseService {
    currentFSE = signal('');
    private http = inject(HttpClient);

    prescriptionResource = signal<any>(null);

    verifyOTP(otp: any): Observable<any> {
        return this.http.post<any>(`/fse/auth/otp/verify`, otp);
    }

    resendOTP(): Observable<any> {
        return this.http.post(`/fse/auth/otp/resend`, null);
    }

    listFiles(): Observable<any> {
        return this.http.get(`/fse/prescription/list-files`);
    }

    refreshTable(): Observable<any> {
        return this.http.get(`/fse/prescription/refresh`);
    }

    getServerDiskDetails(): Observable<any> {
        return this.http.get('/ris-actuator/health/custom/diskSpace');
    }

    getFseServerStatus(): Observable<any> {
        return this.http.get('/fse-actuator/health').pipe(
            switchMap((response: any) => {
                if (response.status === 'UP') return this.http.get('/fse-actuator/health/custom/fseConnection');
                else return of({ status: 'DOWN' });
            })
        );
    }

    getPrescriptions(searchTerm: string): Observable<any> {
        return this.http.get(`${FSE_URL}/executed-prescriptions`, { params: { searchTerm } });
    }

    getComplementsAndRejects(searchTerm: string, inpe: string): Observable<any> {
        return this.http.get(`${FSE_URL}/complements-rejects`, { params: { searchTerm, inpe } });
    }

    makeActeExecuted(exam: any): Observable<any> {
        return this.http.post(`${FSE_URL}/execute`, exam);
    }

    searchPrescription() {
        this.http.get(`/fse/prescription/search?numFSE=${this.currentFSE()}`).subscribe((value) => {
            this.prescriptionResource.set(value);
        });
    }

    submitFSEResponse(response: any): Observable<any> {
        return this.http.post(`/fse/prescription/response`, response);
    }

    saveResponse(response: ComplementRejectResponse): Observable<ComplementRejectResponse> {
        return this.http.post<ComplementRejectResponse>(`${FSE_URL}/complements-rejects/response`, response);
    }

    getRejects(): Observable<any> {
        return this.http.get('/fse/prescription/rejet');
    }

    getComplements(): Observable<any> {
        return this.http.get('/fse/prescription/complements');
    }

    executeActe(acte: any): Observable<any> {
        return this.http.post('/fse/prescription/execute', acte);
    }

    uploadActe(id: number, fseNumber: string, reportId: number): Observable<any> {
        const params = { id, fseNumber, reportId };
        return this.http.post('/fse/prescription/upload-files', null, { params });
    }

    checkPrescription(numFSE: string): Observable<any> {
        console.log(numFSE);

        return this.http.get(`/fse/prescription/search?numFSE=${numFSE}`);
    }

    saveFseConfig(fseConfig: FseConfig): Observable<any> {
        return this.http.post(`${SETTING_URL}/fse-config`, fseConfig);
    }

    removeFseUser(user: FseUserAuthentication): Observable<any> {
        return this.http.delete(`${SETTING_URL}/fse-config/users/${user.id}`);
    }

    getFseConfig(): Observable<FseConfigResponse> {
        return this.http.get<FseConfigResponse>(`${SETTING_URL}/fse-config`);
    }
}
